import React, { FC } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

interface IProps {
    meter:any
};

function round(num:any) {
    if(!num){
      return num
    }
    return Math.round((num + Number.EPSILON) * 100)/100;
}


const CostAvoidanceBaselineMeterTable:FC<IProps> = (props) => {
    let columns:any = []
    if (props.meter.type === "Electric"){
      columns = [
        {
          id:'date',
          accessorKey:'date',
          header: "Month/Year",
          cell: (props: any) => {
            return (
              <div className="center-all">{props.getValue()}</div>
            );
          },
          size: 150,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
            id:'kwh_baseline_cost',
            accessorKey: 'kwh_baseline_cost',
            header: "Baseline KWH Cost",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_baseline',
            accessorKey: 'kwh_baseline',
            header: "Baseline KWH",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_baseline_rate',
            accessorKey: 'kwh_baseline_rate',
            header: "Baseline KWH Rate",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_baseline_cost',
            accessorKey: 'kw_baseline_cost',
            header: "Baseline KW Cost",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_baseline',
            accessorKey: 'kw_baseline',
            header: "Baseline KW",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_baseline_rate',
            accessorKey: 'kw_baseline_rate',
            header: "Baseline KW Rate",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'baseline_cdd',
            accessorKey: 'baseline_cdd',
            header: "Baseline CDD",
            cell: (props: any) => {
                return (
                <div className="center-all">{props.getValue()}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'baseline_hdd',
            accessorKey: 'baseline_hdd',
            header: "Baseline HDD",
            cell: (props: any) => {
                return (
                <div className="center-all">{props.getValue()}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        }
      ]
    }
    if (props.meter.type === "Natural Gas"){
    columns = [
    {
      id:'date',
      accessorKey:'date',
      header: "Month/Year",
      cell: (props: any) => {
        return (
          <div className="center-all">{props.getValue()}</div>
        );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_baseline_cost',
      accessorKey: 'therms_baseline_cost',
      header: "Baseline Therms Cost",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_baseline',
      accessorKey: 'therms_baseline',
      header: "Baseline Therms",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_baseline_rate',
      accessorKey: 'therms_baseline_rate',
      header: "Baseline Therms Rate",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'baseline_cdd',
      accessorKey: 'baseline_cdd',
      header: "Baseline CDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'baseline_hdd',
      accessorKey: 'baseline_hdd',
      header: "Baseline HDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
]
    }
    

    const table = useReactTable({
        data: props.meter.baseline,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
      });

    return <div style={{width:'100%',marginTop:'0.5rem', display:'flex', justifyContent:'center',textAlign:'center'}}>
    <div className="stories-table" style={{ width: table.getTotalSize(), marginBottom: "2em", overflowX: "auto", maxHeight:'550px'}}>
        {table.getHeaderGroups().map((headerGroup: any) => (
          <div key={headerGroup.id} className="tr">
            {headerGroup.headers.map((header: any) => {
              return (
                <div
                  key={header.id}
                  className="th"
                  style={{ width: header.getSize() }}

                >
                  {header.column.columnDef.header}
                </div>
              );
            })}
          </div>
        ))}

        {table.getRowModel().rows.map((row: any) => (
          <div
            key={row.id}
            className="tr"
            style={{ width: table.getTotalSize() }}
          >
            {row.getVisibleCells().map((cell: any) => {
              return (
                <div
                  key={cell.id}
                  className="td"
                  style={{ width: cell.column.getSize() }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              );
            })}
          </div>
        ))}
        
    </div>
    </div>
};

export default CostAvoidanceBaselineMeterTable;


